module.exports = __webpack_public_path__ + "img/bingo_ball-38.368356d6.png";